import React, { useMemo } from 'react'
import { Checkbox, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '~/Store'
import {
  getIsLoadingRoleProductClaims,
  getRoleProductClaims,
} from '~/Store/Role/selectors'

interface Props {
  productId: string
  selectedClaimIds: string[]
  onToggleClaim: (claimId: string, checked: boolean) => void
  onDeselectAll: () => void
}

export const RoleProductPermissions = ({
  productId,
  selectedClaimIds,
  onToggleClaim,
  onDeselectAll,
}: Props) => {
  const { t } = useTranslation()
  const claims = useAppSelector(getRoleProductClaims(productId))
  const isLoading = useAppSelector(getIsLoadingRoleProductClaims(productId))

  // Sắp xếp theo bảng chữ cái (claimType:claimValue) để dễ dò tìm trong danh sách dài.
  const sortedClaims = useMemo(
    () =>
      [...(claims || [])].sort((a, b) =>
        `${a.claimType}:${a.claimValue}`.localeCompare(
          `${b.claimType}:${b.claimValue}`,
        ),
      ),
    [claims],
  )

  return (
    <Spin spinning={isLoading}>
      {!!claims?.length && (
        <div style={{ textAlign: 'right', marginBottom: '8px' }}>
          <a onClick={onDeselectAll}>{t('admin.akDeselectAll')}</a>
        </div>
      )}
      {sortedClaims.map(claim => (
        <div key={claim.guid} style={{ marginBottom: '8px' }}>
          <Checkbox
            checked={selectedClaimIds.includes(claim.guid)}
            onChange={evt => onToggleClaim(claim.guid, evt.target.checked)}
          >
            <code>
              {claim.claimType}:{claim.claimValue}
            </code>
          </Checkbox>
        </div>
      ))}
      {!isLoading && claims?.length === 0 && (
        <span>{t('admin.akNoPermissions')}</span>
      )}
    </Spin>
  )
}
